export enum CurrenciesType {
  THB = 1,
  USD = 2,
}
